import { render } from "./field_submitter.vue?vue&type=template&id=a96674be"
import script from "./field_submitter.vue?vue&type=script&lang=js"
export * from "./field_submitter.vue?vue&type=script&lang=js"

import exportComponent from "/home/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/field_submitter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a96674be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a96674be', __exports__)) {
    api.reload('a96674be', __exports__)
  }
  
  module.hot.accept("./field_submitter.vue?vue&type=template&id=a96674be", () => {
    api.rerender('a96674be', render)
  })

}


export default __exports__